import React, { useCallback } from "react";
import { getTransitionDelayTime } from "../../../utils/get-transition-delay-time";
import Box from "@material-ui/core/Box";
import Zoom from "@material-ui/core/Zoom";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    "@keyframes blink": {
        "50%": {
            opacity: 1,
        },
    },
    rootContainer: {
        width: "400px",
        background: "#F5F6FA",
        borderRadius: "20px",
        margin: "5px",
        padding: "12px 14px 12px 14px",
        display: "inline-block",
        ...theme.typography.chat,

        [theme.breakpoints.down(350)]: {
            width: "calc(100% - 29px)",
        },
        [theme.breakpoints.between(350, 380)]: {
            width: "250px",
        },
        [theme.breakpoints.between(380, 450)]: {
            width: "300px",
        },
        [theme.breakpoints.between(450, 500)]: {
            width: "350px",
        },
    },
    spanContainer: {
        height: "9px",
        width: "9px",
        float: "left",
        margin: "0 3px",
        backgroundColor: "#9E9EA1",
        display: "block",
        borderRadius: "50%",
        opacity: 0.4,

        "&:nth-of-type(1)": {
            animation: "$blink 1s infinite 0.33s",
        },
        "&:nth-of-type(2)": {
            animation: "$blink 1s infinite 0.66s",
        },
        "&:nth-of-type(3)": {
            animation: "$blink 1s infinite 0.99s",
        },
    },
}));
const TypingIndicatorBox = withStyles((theme) => ({
    root: {
        width: "400px",
        [theme.breakpoints.down(350)]: {
            width: "250px",
        },
        [theme.breakpoints.between(351, 400)]: {
            width: "280px",
        },
        [theme.breakpoints.between(401, 480)]: {
            width: "330px",
        },
        [theme.breakpoints.between(481, 550)]: {
            width: "415px",
        },
    },
}))(Box);

const firstStyles = {
    borderRadius: "2px 20px 20px 20px !important",
};
const typingStyles = {
    width: "85px !important",
    paddingLeft: "18px !important",
    paddingRight: "18px !important",
};

const ChatBubbles = ({ messages = [], hasTypingIndicator }) => {
    const {
        rootContainer,
        spanContainer,
    } = useStyles();
    const typingIndicatorKey = messages.length;
    const indicatorDelayTime = getTransitionDelayTime(typingIndicatorKey);

    const TypingIndicator = useCallback(() => (
        <Zoom in style={{ transitionDelay: indicatorDelayTime }}>
            <TypingIndicatorBox>
                <Box
                    className={rootContainer}
                    {...typingStyles}
                    {...(typingIndicatorKey === 0) && firstStyles}
                >
                    <Box component="span" className={spanContainer} />
                    <Box component="span" className={spanContainer} />
                    <Box component="span" className={spanContainer} />
                </Box>
            </TypingIndicatorBox>
        </Zoom>
    ), [indicatorDelayTime, rootContainer, spanContainer, typingIndicatorKey]);

    const renderMessages = () => {
        const reactNodeMessages = messages.map((msg, i) => {
            const delayTime = getTransitionDelayTime(i);
            return (
                <Zoom
                    key={i}
                    in
                    style={{ transitionDelay: delayTime }}
                >
                    <Box
                        className={rootContainer}
                        {...(i === 0) && firstStyles}
                    >
                        {msg}
                    </Box>
                </Zoom>
            );
        });
        if (hasTypingIndicator) {
            reactNodeMessages.push(<TypingIndicator key={typingIndicatorKey} />);
        }
        return reactNodeMessages;
    };

    return renderMessages();
};

export default ChatBubbles;